module.exports = __webpack_public_path__ + "img/paul_n.cd737c52.png";